export enum TableColumnComponentNames {
  StringRender = `String`,
  StringEditor = `agStringInput`,
  ActionsPanel = `ActionsPanel`,
  CheckboxRender = 'CheckboxRender',
  CheckboxCellEditor = 'agCheckboxCellEditor',
  defaultDate = 'agDateInput',
  agStringInput = 'agStringInput',
  agDefault = '',
  StatusRender = 'StatusRenderer',
  EnumRender = 'EnumRender',
}

export class TableColumnType {
  static store = new Map<string, TableColumnType>();

  static Default = new TableColumnType('default', TableColumnComponentNames.agStringInput, null);

  static String = new TableColumnType('string', TableColumnComponentNames.StringRender, null);
  static ActionsPanel = new TableColumnType('actions', TableColumnComponentNames.ActionsPanel, null);

  static Checkbox = new TableColumnType(
    'checkbox',
    TableColumnComponentNames.CheckboxRender,
    TableColumnComponentNames.CheckboxCellEditor,
  );

  static Status = new TableColumnType('status', TableColumnComponentNames.StatusRender, null);

  static AgDefault = new TableColumnType('agDefault', TableColumnComponentNames.CheckboxRender, null);

  static Enum = new TableColumnType('enumList', TableColumnComponentNames.EnumRender, null);

  static get(code: string): TableColumnType {
    return TableColumnType.store.get(code) || TableColumnType.String;
  }
  constructor(
    public code: string,
    public renderer: TableColumnComponentNames,
    public editor: TableColumnComponentNames | null,
  ) {
    TableColumnType.store.set(code, this);
  }
}
